import { Injectable } from '@angular/core';

@Injectable()
export class DateService {

    constructor() {
    }

    fromObjectToString(dateObject) {
        var dd = '' + dateObject.getDate();
        if (dd.length < 2) {
            dd = "0" + dd;
        }
        var mm = '' + (dateObject.getMonth() + 1);
        if (mm.length < 2) {
            mm = "0" + mm;
        }
        var yyyy = '' + dateObject.getFullYear();
        return yyyy + "-" + mm + "-" + dd;
    }
}
